import { JuloUpdateEntry } from "./types"

export const englishLanguageEntry: JuloUpdateEntry = {
  slug: "2026-10-19-english-language",
  date: "2026-10-19",
  title: "Alfred finns nu på engelska",
  description:
    "Nu kan ni använda Alfred på engelska. Håll muspekaren över namnet längst ned i sidomenyn (tryck på det i mobilen) och välj **Svenska** eller **English** under Språk.\n\nSpråket sparas på ert konto, så varje person kan välja det språk som passar bäst – utan att det påverkar någon annan. Kunder kan också välja mellan svenska och engelska på sina jobbsidor.",
  images: [
    {
      src: "/julo-updates/2026-10-19-english-language/1-language-switcher.png",
      alt: "Kontomenyn längst ned i sidomenyn med valet Språk, där Svenska och English visas och English är valt.",
    },
  ],
}
